import { httpClient } from "./http-client";
import type { ApiResponse } from "../../shared/types/api";
import type {
  ForgotPasswordRequest,
  ResetPasswordRequest,
  TokenVerifyResponse,
} from "../../domain/types/password-reset";

const MES_PASSWORD_RESET_ENDPOINTS = {
  FORGOT_PASSWORD: "/api/mes/auth/forgot-password",
  VERIFY_TOKEN: "/api/mes/auth/reset-password/verify",
  RESET_PASSWORD: "/api/mes/auth/reset-password",
} as const;

class PasswordResetApiService {
  /**
   * 비밀번호 찾기 요청.
   * 이메일과 이름이 일치하면 재설정 이메일 발송.
   */
  async requestPasswordReset(
    data: ForgotPasswordRequest
  ): Promise<ApiResponse<boolean>> {
    const response = await httpClient.post<ApiResponse<boolean>>(
      MES_PASSWORD_RESET_ENDPOINTS.FORGOT_PASSWORD,
      data
    );
    return response.data;
  }

  /**
   * 토큰 유효성 검증.
   * 비밀번호 재설정 페이지 진입 시 호출.
   */
  async verifyToken(token: string): Promise<ApiResponse<TokenVerifyResponse>> {
    const response = await httpClient.get<ApiResponse<TokenVerifyResponse>>(
      `${MES_PASSWORD_RESET_ENDPOINTS.VERIFY_TOKEN}?token=${encodeURIComponent(token)}`
    );
    return response.data;
  }

  /**
   * 비밀번호 재설정.
   */
  async resetPassword(
    data: ResetPasswordRequest
  ): Promise<ApiResponse<boolean>> {
    const response = await httpClient.post<ApiResponse<boolean>>(
      MES_PASSWORD_RESET_ENDPOINTS.RESET_PASSWORD,
      data
    );
    return response.data;
  }
}

export const passwordResetApiService = new PasswordResetApiService();
